import type { Bookmark } from "../types";
import { BookmarkTile } from "./BookmarkTile";
import { useLongPressReorder } from "../hooks/useLongPressReorder";

type BookmarkGridProps = {
  bookmarks: Bookmark[];
  onEdit: (bookmark: Bookmark) => void;
  onReorder: (activeId: string, overId: string) => void;
};

export function BookmarkGrid({ bookmarks, onEdit, onReorder }: BookmarkGridProps) {
  const drag = useLongPressReorder(onReorder);

  if (bookmarks.length === 0) {
    return (
      <section className="empty-state" aria-live="polite">
        <p>一致するブックマークがありません。</p>
      </section>
    );
  }

  return (
    <section className="bookmark-grid" aria-label="ブックマーク">
      {bookmarks.map((bookmark) => (
        <BookmarkTile
          key={bookmark.id}
          bookmark={bookmark}
          onEdit={onEdit}
          dragHandlers={drag.bind(bookmark.id)}
          isReordering={drag.activeId === bookmark.id || drag.interactionBlocked}
          onInteractionClick={drag.blockClickIfNeeded}
        />
      ))}
    </section>
  );
}
